/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { PublishedSchemaFilter } from '../../../../types/PublishedSchemaFilter';
import { PublishedSchemaSort } from '../../../../types/PublishedSchemaSort';

export const PublishedSchemaSearchRequest: core.serialization.Schema<
    serializers.PublishedSchemaSearchRequest.Raw,
    Truvity.PublishedSchemaSearchRequest
> = core.serialization.object({
    filter: core.serialization.list(PublishedSchemaFilter).optional(),
    sort: core.serialization.list(PublishedSchemaSort).optional(),
});

export declare namespace PublishedSchemaSearchRequest {
    export interface Raw {
        filter?: PublishedSchemaFilter.Raw[] | null;
        sort?: PublishedSchemaSort.Raw[] | null;
    }
}
